export enum BoundedNameValidationError {
  MinSize = "MIN_SIZE",
  MaxSize = "MAX_SIZE",
  DuplicateName = "DUPLICATE_NAME",
}
